import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/ic_close@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-1fe0d06a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content_search content_top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close",
  src: _imports_0,
  alt: "",
  style: {"opacity":"0"}
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择生产人员", -1))
const _hoisted_5 = { class: "content_total" }
const _hoisted_6 = { class: "content_list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "content_list_item_name" }

import { onMounted, ref, reactive } from 'vue'
    import { materialDistributeExt } from '@/apis/ExWarehouse'
    import { getFindAll, allUser } from '@/apis/PlanningAPI'
    import { model } from '@/interface'
    import { judgmentPlatform } from "@/utils/utils"
    import vSearch from '@/components/common/Search.vue'

    // 搜索数据接口
    interface form extends model {
        total: number,
        name: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
        show: {
            type: Boolean,
            required: true
        }
    },
  emits: ['close', 'value'],
  setup(__props, { emit }) {

const props = __props

    const form = reactive<form>({
        capacity: 50,
        page: 0,
        total: 0,
        name: '',
    })

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)

    // 搜索框
    const searchInput = (data: any) => {
        form.page = 0
        finished.value = false
        list.value = []
        form.name = data
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 返回上一页带参数
    const jump = (item: any) => {
        emit('value', item)
    }

    // 获取物料列表数据
    const onLoad = async () => {
        loading.value = true;
        allUser({ name: form.name })
            .then(res => {
                loading.value = false;
                if (res.code === 200 && res.data && res.data.length !== 0) {
                    form.total = res.data.length
                    list.value = res.data
                } else {
                    finished.value = true;
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
    }

    

    

    // 关闭回调
    const close = () => {
        emit('close')
    }

    onMounted(() => {
        onLoad()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((props.show) = $event)),
    "close-on-click-overlay": false,
    position: "bottom",
    round: "",
    style: { height: '80%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "title" }, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("img", {
              class: "close",
              src: _imports_0,
              alt: "",
              onClick: close
            })
          ]),
          _createVNode(vSearch, {
            onSearchInput: searchInput,
            onSubmit: submit,
            isShow: false,
            placeholder: "搜索姓名"
          })
        ]),
        _createElementVNode("div", _hoisted_5, "共" + _toDisplayString(_unref(form).total) + "条数据", 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content_list_item",
              key: i,
              onClick: ($event: any) => (jump(item))
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.name) + " | " + _toDisplayString(item.dmodel.name), 1)
            ], 8, _hoisted_7))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})